<template>
  <b-modal
    id="mSaveCalcWriteFine"
    v-model="localActive"
    centered
    hide-footer
    hide-header
    @show="onShowModal"
    @close="localActive = false"
  >
    <div class="m-write-fine">
      <svg
        class="m-write-fine-close"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="localActive = false"
      >
        <path
          d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
          fill="#8E9CBB"
        />
        <path
          d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
          fill="#8E9CBB"
        />
      </svg>
      <div class="m-write-fine-title">
        {{ editFineData ? "Редактировать штраф" : "Выписать штраф" }}
      </div>

      <div class="m-write-fine-form">
        <div class="m-write-fine-form-row">
          <c-select
            v-model="basisLocalValue"
            class="m-write-fine-form-row-basis"
            :class="{ 'm-write-fine-form-row-basis-required': basisErrorMessage.length > 0 }"
            type="select"
            label="Основание штрафа"
            :searchable="true"
            :items="items"
            :groups="groups"
            placeholder="Выберите основание штрафа"
            :required="basisErrorMessage"
            @input="setDefaultFineValue"
          />
        </div>
        <div class="m-write-fine-form-row" :class="{ 'm-write-fine-form-row-required': amountErrorMessage.length > 0 }">
          <c-input
            v-model="amountLocal"
            class="m-write-fine-form-row-summ"
            :class="{ 'm-write-fine-form-row-summ-required': amountErrorMessage.length > 0 }"
            label="Сумма, ฿"
            :input-text-condition="amountErrorMessage"
            placeholder="0"
            type="integer-number"
          />
          <c-input
            v-model="authorLocalValue"
            label="Автор премии"
            class="m-write-fine-form-row-author"
            type="select"
            placeholder="Выберите автора штрафа"
            :items="authorsLocalItems"
            :searchable="true"
            :clearable="true"
          />
        </div>
       <!-- <c-input
          ref="modalWriteFineCommentInput"
          v-model="comment"
          class="m-write-fine-form-comment"
          type="textarea"
          :textarea-max-length="500"
          :clearable="true"
          placeholder="Комментарий"
        />-->
      </div>

      <div class="m-write-fine-actions">
        <c-button size="large" class="m-write-fine-actions-cancel" label="Отменить" @click="cancel" />
        <c-button
          class="m-write-fine-actions-save"
          label="Сохранить"
          color="primary"
          size="large"
          @click="submitForm"
        />
      </div>
    </div>
  </b-modal>
</template>

<script>
import Input from "@/components/controls2/Input";
import Button from "@/components/controls2/Button";
import Select from "@/components/controls2/Select";

export default {
  name: "m-production-write-premium",

  components: {
    "c-input": Input,
    "c-button": Button,
    "c-select": Select,
  },

  props: ["active", "calcData", "record", "editFineData"],

  data() {
    return {
      localActive: false,
      amountLocal: "",
      amountErrorMessage: "",
      basisLocalValue: null,
      basisErrorMessage: "",
      authorLocalValue: null,
      authorsLocalItems: [],
      is_external: false,
      comment: "",
      date: "",
      groups: [],
      items: [],
    };
  },

  watch: {
    localActive(value) {
      if (!value) {
        this.$emit("close");
        setTimeout(() => {
          this.amountLocal = "";
          this.amountErrorMessage = "";
          this.basisLocalValue = null;
          this.basisErrorMessage = "";
          this.authorLocalValue = null;
          this.authorsLocalItems = [];
          this.is_external = false;
          this.comment = "";
          this.date = "";
          this.groups = [];
          this.items = [];
          this.submitAttempt = false;
        }, 200);
      }
    },
    active(value) {
      this.localActive = value;
    },
    data(value) {
      this.postLocalItems = value.posts.map((post) => ({
        label: post.name,
        value: post.code,
      }));
    },
    amountLocal(value) {
      if (this.submitAttempt) {
        if (value === "" || value === null) {
          this.amountErrorMessage = "Обязательное поле";
        } else {
          this.amountErrorMessage = "";
        }
      }
    },
    basisLocalValue(value) {
      if (this.submitAttempt) {
        if (value === null) {
          this.basisErrorMessage = "Обязательное поле";
        } else {
          this.basisErrorMessage = "";
        }
      }
    },
  },

  mounted() {},

  methods: {
    setDefaultFineValue() {
      if (!this.basisLocalValue) return;
      //console.log(this.basisLocalValue);
      this.$store
        .dispatch("calculations/getFineInfoForWorker", {
          workerId: this.record.id,
          reasonId: this.basisLocalValue.value,
        })
        .then((res) => {
          if (res !== -1) this.amountLocal = res;
        });
    },
    onShowModal() {
      
      this.groups = [];
      this.items = [];
      Object.entries(this.calcData.fines).forEach(([groupName, groupItems]) => {
        this.groups.push({ name: groupName, label: groupName });
        Object.entries(groupItems).forEach(([itemKey, item]) => {
          if (item.posts.includes(this.record.codeGroup) || item.posts.length==0) {
            this.items.push({ label: item.description, value: itemKey, group: groupName });
          }
        });
      });
      const currentUserId = this.$store.state.userId;
      this.authorsLocalItems = [];
      this.$store.dispatch("personalEmployee/getWorkersList", currentUserId).then((res) => {
        res.response.forEach((item) => {
          if (!item.is_user) {
            this.authorsLocalItems.push({ value: item.id, label: item.name, isUser: item.is_user });
          }
        });
      });

      if (this.editFineData) {
        setTimeout(() => {
          let author = null;
          const c = this.authorsLocalItems.findIndex(
            (author) => author && this.editPremiumData && this.editPremiumData.author_id && author.value.toString() === this.editFineData.author_id.toString(),
          );
          if (c !== -1) author = this.authorsLocalItems[c];

          this.basisLocalValue = {
            label: this.editFineData.reason,
            value: this.editFineData.reason_id,
          };
          this.amountLocal = this.editFineData.amount;
          this.authorLocalValue = author;
          this.date = this.editFineData.date;
          this.comment = this.editFineData.comment;
          this.is_external = this.editFineData.is_external;
          this.calc_id = this.editFineData.calc_id;

          if (this.editFineData.comment !== undefined && this.editFineData.comment !== null) {
            this.$refs.modalWriteFineCommentInput.textValue = this.editFineData.comment;
            this.$refs.modalWriteFineCommentInput.$refs.textareaValue.innerHTML = this.editFineData.comment;
          }
        }, 300);
      }
    },
    cancel() {
      this.localActive = false;
    },
    submitForm() {
      let isValidForm = true;

      if (this.amountLocal === "" || this.amountLocal === null) {
        this.amountErrorMessage = "Обязательное поле";
        isValidForm = false;
        this.submitAttempt = true;
      }

      if (this.basisLocalValue === null) {
        this.basisErrorMessage = "Обязательное поле";
        isValidForm = false;
        this.submitAttempt = true;
      }

      if (isValidForm) {
        this.cancel();
        if (this.editFineData) {
          this.$emit("editFine", {
            reason: this.basisLocalValue.label,
            reason_id: this.basisLocalValue.value,
            amount: this.amountLocal,
            author_id: this.authorLocalValue !== null ? this.authorLocalValue.value : null,
            date: this.date,
            comment: this.comment,
            is_external: this.is_external,
            calc_id: this.calc_id,
          });
        } else {
          this.$emit("createFine", {
            reason: this.basisLocalValue.label,
            reason_id: this.basisLocalValue.value,
            amount: this.amountLocal,
            author_id: this.authorLocalValue !== null ? this.authorLocalValue.value : null,
            date: this.date,
            comment: this.comment,
            is_external: this.is_external,
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.m-write-fine {
  backface-visibility: visible !important;

  &-close {
    cursor: pointer;
    position: absolute;
    top: 14px;
    right: 12px;
  }

  &-title {
    font-weight: 500;
    font-size: 18px;
    line-height: 120%;
  }

  &-form {
    display: flex;
    flex-direction: column;
    margin-top: 29px;
    width: 100%;
    max-height: 400px;

    @media screen and (max-width: 700px) {
      padding-left: 0;
      max-height: calc(100vh - 200px);
    }

    &-row {
      display: flex;
      position: relative;
      align-items: center;
      margin-bottom: 24px;

      &-required {
        padding-bottom: 22px;
      }

      @media screen and (max-width: 700px) {
        flex-direction: column;
        align-items: flex-start;
      }

      &-basis {
        max-width: 100%;
        width: 100%;

        & ::v-deep .c-select__icon {
          margin-bottom: 11px !important;
          margin-right: -4px !important;
        }

        & ::v-deep .c-select__value {
          height: 30px;
        }

        &-required {
          padding-bottom: 22px;
        }
      }

      &-trash {
        position: absolute;
        top: 20px;
        right: -45px;

        @media screen and (max-width: 700px) {
          display: none;
        }
      }

      &-summ {
        max-width: 100px;
        width: 100%;
        margin-right: 28px;

        &::v-deep .c-input-required-text {
          white-space: normal !important;
        }

        @media screen and (max-width: 700px) {
          max-width: 50%;
          margin-bottom: 24px;
        }

        &-required {
          @media screen and (max-width: 700px) {
            padding-bottom: 22px;
          }
        }
      }

      &-author {
        //max-width: 357px;
        width: 100%;

        @media screen and (max-width: 700px) {
          max-width: 100%;
        }

        &-required {
          padding-bottom: 22px;
        }
      }

      &-required {
        padding-bottom: 22px;

        @media screen and (max-width: 700px) {
          padding-bottom: 0;
        }
      }
    }

    &-comment {
      max-width: 100%;
      width: 100%;
    }
  }

  &-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 40px;

    @media screen and (max-width: 700px) {
      width: 100%;
      box-shadow: 0px 0px 15px rgba(8, 20, 45, 0.3);
      position: fixed;
      bottom: 0;
      left: 0;
    }

    &-cancel {
      @media screen and (max-width: 700px) {
        width: 50%;
        border-radius: 0 !important;
      }

      ::v-deep & .c-button__wrapper {
        height: 38px !important;

        @media screen and (max-width: 768px) {
          display: flex;
          justify-content: center;
          width: 100%;
          border-radius: 0 !important;
        }
      }
    }

    &-save {
      margin-left: 10px;

      @media screen and (max-width: 700px) {
        border-radius: 0 !important;
        margin-left: 0;
        width: 50%;
      }

      ::v-deep & .c-button__wrapper {
        height: 38px !important;

        @media screen and (max-width: 700px) {
          display: flex;
          justify-content: center;
          width: 100%;
          border-radius: 0 !important;
        }
      }
    }
  }
}
</style>
